// Ajuste o padding top da body de acordo com a altura do menu
function setBodyPdTop() {
  const $header = $('.header');
  const $menuFull = $('#menu');
  let headerHeight = $header.outerHeight();
  let menuHeight = $menuFull.outerHeight();
  let pagePaddingTop = 0;
  let menuFullTop = 0;
  if ($header.hasClass('fixed')) {
    pagePaddingTop += headerHeight;
  }
  if ($menuFull.hasClass('fixed')) {
    menuFullTop = headerHeight;
    pagePaddingTop += menuHeight;
  }
  if ($('body').hasClass('header-transparent')) {
    pagePaddingTop = 0;
    menuFullTop = headerHeight;
  }
  $menuFull.css('top', menuFullTop);
  $('body').css('padding-top', pagePaddingTop);
}
setBodyPdTop();
$(window).on(
  'hresize ',
  debounce(function () {
    setBodyPdTop();
  }, 100),
);
$(document).ready(function () {
  /* if ($('.header-logo img').length) {
    $('.header-logo img').on('load', function () {
      setBodyPdTop();
      setTimeout(setBodyPdTop, 500);
    });
  } */
  setBodyPdTop();
  setTimeout(setBodyPdTop, 100);
});

// Força logo centralizado (Mobile & Tablet)
function fixCenterLogo() {
  if ($('.header-logo').hasClass('force-center') && (isMedia('xs') || isMedia('sm') || isMedia('md'))) {
    const ml = ($('.header-logo-wrp').width() - 25 - $('.header-logo').width()) / 2;
    //$('.header-logo').css('margin-left', ml);
    $('.header-logo')[0].style.setProperty('--ml', ml + 'px');
    $('.header-logo').removeClass('pendding');
  }
}
if ($('.header-logo.force-center').length > 0) {
  fixCenterLogo();
  $(window).on(
    'hresize ',
    debounce(function () {
      fixCenterLogo();
    }, 100),
  );
}

// Ajusta o espaçamento do conteúdo do slide quando o topo é transparente
function fixHeaderTranspSlideContent() {
  if ($('body').hasClass('header-transparent')) {
    const $firstSec = $('#sections-home .home-section').first();
    if ($firstSec.hasClass('slide')) {
      const $carousel = $firstSec.find('.carousel');
      $carousel.addClass('slide-expand');
      let paddingContent = $('.header').outerHeight();
      paddingContent += $('.menu-full').outerHeight();
      paddingContent -= 50;
      $carousel.find('.slide-item').each(function () {
        const $slideItem = $(this);
        $slideItem.find('img').css('height', $slideItem.outerHeight() + paddingContent);
      });
      $firstSec.find('.img-overlay').css('padding-top', paddingContent);
      if ($carousel.hasClass('slick-slider')) {
        $carousel.slick('resize');
      }
    }
  }
}

// Oculto ou exibe o menu ao relizar o scroll na página
(function () {
  'use strict';
  const $menu = $('.menu-full.fixed');
  let lastScrollTop = 200;
  if ((isMedia('xl') || isMedia('lg')) && $menu.length > 0) {
    $(window).on(
      'scroll',
      debounce(function () {
        if ($('.menu-full').hasClass('fixed')) {
          const scrollTop = $(window).scrollTop() >= 0 ? $(window).scrollTop() : 0;
          if (scrollTop > lastScrollTop) {
            $menu.addClass('hidden');
          } else {
            $menu.removeClass('hidden');
          }
          lastScrollTop = scrollTop;
        }
      }, 50),
    );
  }
})();

// Aplica o fundo do menu ao relizar o scroll na página
(function () {
  'use strict';
  if ($('body').hasClass('header-transparent') && $('.header').hasClass('fixed')) {
    const $header = $('.header');
    const $menuFull = $('.menu-full');
    $(window).on(
      'scroll',
      debounce(function () {
        const scrollTop = $(window).scrollTop();
        if (scrollTop >= 200) {
          $header.addClass('fixed-active');
          if ($menuFull.length) {
            $menuFull.addClass('fixed-active');
          }
        } else {
          $header.removeClass('fixed-active');
          if ($menuFull.length) {
            $menuFull.removeClass('fixed-active');
          }
        }
      }, 50),
    );
  }
})();

// Exibe / Oculta busca mobile
(function () {
  'use strict';

  // Variáveis
  const $searchBtnToggle = $('.header-search-btn-mb');
  const $searchEl = $('.header-search-wrp');
  const $searchInput = $('.header-search-wrp #header-search');
  const $searchSideInput = $('#search-side-input');

  // Evento de clique no botão
  $searchBtnToggle.on('click', function (ev) {
    ev.preventDefault();
    toggleSearch();
  });

  // Exibe busca
  function showSearch() {
    $searchBtnToggle.addClass('active');
    if ($searchBtnToggle.hasClass('open-side-search')) {
      sideOpen('search-side');
    } else {
      $searchEl.slideDown('fast', function () {
        $searchInput.focus();
      });
    }
  }
  $('#search-side').on('side-open', function () {
    setTimeout(() => {
      $searchSideInput.focus().select();
    }, 500);
  });

  // Oculta busca
  function hideSearch() {
    $searchBtnToggle.removeClass('active');
    if ($searchBtnToggle.hasClass('open-side-search')) {
      sideClose('search-side');
    } else {
      $searchEl.slideUp('fast');
      $searchInput.val('');
    }
  }
  $('#search-side').on('side-close', function () {
    $searchBtnToggle.removeClass('active');
    //$searchSideInput.val('');
  });

  // Exibe ou oculta a busca
  function toggleSearch() {
    if (!$searchBtnToggle.hasClass('active')) {
      showSearch();
    } else {
      hideSearch();
    }
  }

  // Exibe o busca ao voltar pro Desktop
  $(window).on(
    'hresize',
    debounce(function () {
      if (isMedia('xl') || isMedia('lg')) {
        if (!$searchBtnToggle.hasClass('open-side-search')) {
          showSearch();
        }
      } else {
        if (!$('.header').hasClass('search-expanded-mb')) {
          hideSearch();
        }
      }
    }, 100),
  );
})();

// Autocomplete
(function () {
  'use strict';
  if (!previewMode && $('#header-search').length > 0 && $('#header-search').hasClass('search-autocomplete')) {
    // Variáveis
    const urlSearch = urlBase + 'core/acoes/themes/' + baseTheme + '/busca_produtos.php';
    let urlSearchAll = urlBase + 'search/';
    const $searchInput = $('#header-search');
    const $searchCat = $('#header-search-category');
    const categoriasStore = $infosBase.data('categories');
    const $tags = $('.header-search-tags');

    // Retorna o ID da categoria com base da slug passada
    function getCategoryID(catSlug) {
      if (categoriasStore && typeof categoriasStore === 'object' && categoriasStore.length > 0) {
        const catFind = categoriasStore.filter((cat) => cat['seo_url'] == catSlug)[0];
        if (catFind) {
          return catFind.id;
        }
      }
      return false;
    }

    // Inicializa o plugin de busca
    $searchInput.autocomplete({
      serviceUrl: urlSearch,
      noCache: false,
      minChars: 3,
      width: '100%',
      zIndex: 2,
      appendTo: '.header-search-wrp',
      showNoSuggestionNotice: true,
      deferRequestBy: 100,
      maxHeight: 420,
      params: {
        category: $searchCat.val(),
        category_id: getCategoryID($searchCat.val()),
        store_token: publicToken,
        url_base: urlBase,
        tags: $tags.val(),
      },
      noSuggestionNotice: 'Nenhum produto encontrado.',
      onSelect: function (suggestion) {
        //console.log(suggestion);
        location.href = suggestion.data.url;
      },
      beforeRender: function (container) {
        container.append(
          '<a href="#" class="btn btn-full suggestions-see-all">Ver todos os resultados <svg viewBox="0 0 32 32"><path d="M 12.96875 4.28125 L 11.53125 5.71875 L 21.8125 16 L 11.53125 26.28125 L 12.96875 27.71875 L 23.96875 16.71875 L 24.65625 16 L 23.96875 15.28125 Z"/></svg></a>',
        );
      },
      onSearchStart: function (params) {
        $('.autocomplete-suggestions')
          .html(
            `<div class="suggestions-loading">
          <div class="suggestion-load">
            <div class="shimmer suggestion-load-img"></div>
            <div class="suggestion-load-infos">
              <div class="shimmer-text suggestion-load-title"></div>
              <div class="shimmer-text suggestion-load-price"></div>
            </div>
          </div>
          <div class="suggestion-load">
            <div class="shimmer suggestion-load-img"></div>
            <div class="suggestion-load-infos">
              <div class="shimmer-text suggestion-load-title"></div>
              <div class="shimmer-text suggestion-load-price"></div>
            </div>
          </div>
          <div class="suggestion-load">
            <div class="shimmer suggestion-load-img"></div>
            <div class="suggestion-load-infos">
              <div class="shimmer-text suggestion-load-title"></div>
              <div class="shimmer-text suggestion-load-price"></div>
            </div>
          </div>
        </div>`,
          )
          .show();
      },
      formatResult: function (suggestion, currentValue) {
        //console.log(suggestion);
        const prod = suggestion.data;
        let prodTitle = prod.title;
        const regex = new RegExp(currentValue, 'i');
        const match = prodTitle.match(regex);
        if (match && match[0]) {
          prodTitle = prodTitle.replace(match[0], '<strong>' + match[0] + '</strong>');
        }
        return `<div class="suggestion-prod">
          <div class="suggestion-prod-img"><img src="${prod.image}" /></div>
          <div class="suggestion-prod-infos">
            <div class="suggestion-prod-title">${prodTitle}</div>
            <div class="suggestion-prod-price">${prod.price}</div>
          </div>
        </div>`;
      },
    });

    // Ao alterar uma categoria
    $searchCat.on('change', function () {
      if ($searchInput.val() != '') {
        $searchInput.autocomplete('setOptions', {
          params: {
            category: $searchCat.val(),
            category_id: getCategoryID($searchCat.val()),
            store_token: publicToken,
            url_base: urlBase,
          },
        });
        $searchInput.autocomplete().onValueChange();
      }
    });

    // Ao clicar no botão para ver todos os resultados
    $('body').on('click', '.suggestions-see-all', function (ev) {
      ev.preventDefault();
      //console.log(getFullSearchURL());
      location.href = getFullSearchURL();
    });

    // Obtém a url de busca geral
    function getFullSearchURL() {
      const query = $searchInput.val();
      const category = $searchCat.val();
      /* if (category) {
        urlSearchAll = urlBase + category;
      } */
      return encodeURI(urlSearchAll + '?q=' + query);
    }
  }
})();

// Autocomplete (Search Side)
(function () {
  'use strict';
  if (!previewMode && $('#search-side').length > 0) {
    // Variáveis
    const urlSearch = urlBase + 'core/acoes/themes/' + baseTheme + '/busca_produtos.php';
    let urlSearchAll = urlBase + 'search/';
    const $searchInput = $('#search-side-input');
    const $tags = $('.header-search-tags');
    const $results = $('.search-side-list');
    const $loader = $('.search-side-loader');
    const $noResults = $('.search-side-noresults');
    let timerSearch;
    $searchInput.on('input', function () {
      clearTimeout(timerSearch);
      let query = $searchInput.val().trim();
      if (query.length >= 3) {
        $loader.show();
        $noResults.hide();
        $results.html('');
        timerSearch = setTimeout(function () {
          $.ajax({
            url: urlSearch,
            type: 'GET',
            data: {
              query: query,
              store_token: publicToken,
              url_base: urlBase,
              tags: $tags.val(),
            },
            dataType: 'json',
            success: function (data) {
              console.log(data);
              $loader.hide();
              if (data.suggestions.length > 0) {
                $.each(data.suggestions, function (index, item) {
                  let prodTit = item.data.title;
                  let highlightedText = prodTit.replace(
                    new RegExp(query, 'gi'),
                    (match) => `<span class="highlight">${match}</span>`,
                  );
                  const $oldPrice =
                    item.data?.price_old != 'R$ 0,00' ? `<span class="old">${item.data.price_old}</span>` : '';
                  $results.append(`<a href="${item.data.url}" class="prod-side prod-side-link">
                    <div class="img img-rounded img-border prod-side-img">
                      <img src="${item.data.image}" alt="" width="85px" height="85px">
                    </div>
                    <div class="prod-side-infos">
                      <div class="prod-side-tit">${highlightedText}</div>
                      <div class="prod-side-price">
                        ${$oldPrice}
                        <span class="new">${item.data.price}</span>
                      </div>
                    </div>
                  </a>`);
                });
              } else {
                $noResults.show();
              }
            },
            error: function () {
              $loader.hide();
              //$noResults.find('span').text('Erro ao buscar os produtos.');
              $noResults.show();
            },
          });
        }, 500);
      } else {
        $loader.hide();
        $results.html('');
      }
    });
  }
})();

// ------------------------------------
// Barra itens (Carrosel)
// ------------------------------------
const topBarCarroselClass = '.header-bar-content';
topBarInitSlick();
$(window).on(
  'hresize ',
  debounce(function () {
    topBarDestroySlick();
    setTimeout(() => {
      topBarInitSlick();
    }, 100);
  }, 100),
);
// Desabilita o plugin de carrosel
function topBarDestroySlick() {
  const $topBarCarrosel = $(topBarCarroselClass);
  $topBarCarrosel.each(function () {
    const $carroselItem = $(this);
    if ($carroselItem.hasClass('slick-slider')) {
      $carroselItem.slick('unslick');
    }
  });
}
// Aplica o plugin de carrosel
function topBarInitSlick() {
  const $topBarCarrosel = $(topBarCarroselClass);
  $topBarCarrosel.each(function () {
    const $carroselItem = $(this);
    const enableVertical = $carroselItem.hasClass('carousel-vertical');
    const enableDesktop = $carroselItem.hasClass('carousel-desktop');
    const enableDesktopVerify = enableDesktop ? true : isMedia('sm') || isMedia('xs');
    if (
      !$carroselItem.hasClass('slick-initialized') &&
      $carroselItem.find('.header-bar-item').length > 1 &&
      enableDesktopVerify
    ) {
      $carroselItem.slick({
        slidesToShow: 1,
        slidesToScroll: 1,
        vertical: enableVertical,
        infinite: true,
        autoplay: true,
        autoplaySpeed: 3000,
        adaptiveHeight: false,
        dots: false,
        arrows: false,
        pauseOnFocus: false,
        pauseOnHover: false,
      });
      setBodyPdTop();
    }
  });
}
